import { SET_CONTENT_SEGMENTS, SET_DOWNLOADS } from './constants';

export const setDownloads = (downloads: string[]) => ({
  type: SET_DOWNLOADS,
  downloads,
});

export const setContentSegments = (contentSegments: any) => ({
  type: SET_CONTENT_SEGMENTS,
  contentSegments,
});
